import { render, staticRenderFns } from "./CheckoutDetailsWidget.vue?vue&type=template&id=6bfdd009"
import script from "./CheckoutDetailsWidget.vue?vue&type=script&lang=js"
export * from "./CheckoutDetailsWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports